import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [{
  exact: true,
  path: '/home/operated/operation',
  owner: '/home',
  authority: 'operation',
  component: Loadable({
    loader: () => import('./list'),
    loading: () => <RouteLoading />
  })
},{
  exact: true,
  path: '/home/operated/operation/addOrEdit/:method/:id/:operationId/:status',
  owner: '/home',
  authority: 'operation',
  component: Loadable({
    loader: () => import('./addOrEdit'),
    loading: () => <RouteLoading />
  })
}];